/*
 * The suit bought as its three pieces.
 *
 * This is the buy control on a linked suit - the suit's own size buttons are
 * not rendered - so it has to do everything they did: hold a size per piece,
 * keep the total honest, and put the result in the basket.
 *
 * The price rule is the point of the whole feature: take all three and it costs
 * what the suit costs, whatever sizes they are. Charging the sum of the pieces
 * would bill a man extra for not being a standard drop, which is the exact
 * problem this is here to solve. Take fewer and each is its own price, because
 * then it is not a suit.
 */
(function () {
  var root = document.querySelector('[data-tcsep]');
  if (!root) return;

  var setPrice = Number(root.getAttribute('data-set-price') || 0);
  var rows = [].slice.call(root.querySelectorAll('[data-tcsep-row]'));
  var totalEl = root.querySelector('[data-tcsep-total]');
  var totalWasEl = root.querySelector('[data-tcsep-total-was]');
  var saveEl = root.querySelector('[data-tcsep-save]');
  var totalLabel = root.querySelector('[data-tcsep-total-label]');
  var addBtn = root.querySelector('[data-tcsep-add]');
  var addLabel = root.querySelector('[data-tcsep-add-label]');
  var note = root.querySelector('[data-tcsep-note]');

  /*
   * Shopify writes prices in pence. Two decimals always, because the figures
   * Liquid rendered into this panel came from the money filter and carry them:
   * a total that drops to "£170" beside a row still reading "£115.00" looks
   * like a different kind of number rather than the same one added up.
   *
   * And the pound sign is learned rather than assumed, for the same reason the
   * cart's set headings learn it: Shopify Markets prices this panel in the
   * shopper's own currency, so a Swiss customer read CHF on every row and £ on
   * the total underneath them. Liquid has already written one correctly formatted
   * price into the first row — prefix and suffix are copied off that, because not
   * every currency goes in front of the number.
   */
  var SHAPE = null;

  function learnShape(text) {
    if (SHAPE || !text) return;
    var run = String(text).match(/\d[\d.,\u00a0 ]*\d|\d/);
    if (run) {
      SHAPE = { prefix: text.slice(0, run.index), suffix: text.slice(run.index + run[0].length) };
    }
  }

  function money(pence) {
    var s = (pence / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d)\.)/g, ',');
    if (SHAPE) return SHAPE.prefix + s + SHAPE.suffix;
    return '£' + s;
  }

  function sizesIn(row) {
    return [].slice.call(row.querySelectorAll('[data-tcsep-size]'));
  }

  function pickedIn(row) {
    return row.querySelector('[data-tcsep-size][aria-pressed="true"]');
  }

  function isOn(row) {
    return row.querySelector('[data-tcsep-tick]').checked;
  }

  function chosen() {
    return rows.filter(isOn);
  }

  function choose(row, btn) {
    sizesIn(row).forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
  }

  function draw() {
    rows.forEach(function (r) {
      r.classList.toggle('is-off', !isOn(r));
      var p = pickedIn(r);
      var priceEl = r.querySelector('[data-tcsep-price]');
      /* Read before it is written over: what Liquid put there is the only
         correctly formatted price on the panel. */
      learnShape(priceEl.textContent);
      if (p) priceEl.textContent = money(Number(p.getAttribute('data-price') || 0));

      /* The was-price follows the size, because it is a per-variant figure —
         one size on offer and the next at full price is a real thing in this
         catalogue, and showing the first size's saving against the third's
         price would be a lie the customer only finds at checkout. */
      var wasEl = r.querySelector('[data-tcsep-was]');
      if (wasEl && p) {
        var was = Number(p.getAttribute('data-compare') || 0);
        var now = Number(p.getAttribute('data-price') || 0);
        if (was > now) {
          wasEl.textContent = money(was);
          wasEl.hidden = false;
        } else {
          wasEl.textContent = '';
          wasEl.hidden = true;
        }
      }
    });

    var on = chosen();
    var all = on.length === rows.length;
    var missing = on.filter(function (r) { return !pickedIn(r); });

    var sum = all
      ? setPrice
      : on.reduce(function (a, r) {
          var p = pickedIn(r);
          return a + (p ? Number(p.getAttribute('data-price') || 0) : 0);
        }, 0);

    totalLabel.textContent = all
      ? 'All three'
      : (on.length === 0 ? 'Nothing chosen' : (on.length === 1 ? 'One piece' : on.length + ' pieces'));
    totalEl.textContent = money(sum);

    /*
     * What the chosen pieces were worth before the sale, and the saving.
     *
     * Summed from the pieces rather than taken from the suit's own compare-at:
     * this panel is buying these pieces, and their full prices are what a
     * customer would otherwise have paid for them. A piece with no was-price
     * counts at its current price, so the comparison never overstates itself.
     *
     * Shown only while every chosen piece has a size, because until then the
     * total is a running subtotal and a saving against it would move on every
     * tap.
     */
    if (totalWasEl && saveEl) {
      var priced = on.length > 0 && !missing.length;
      var wasTotal = priced
        ? on.reduce(function (a, r) {
            var p = pickedIn(r);
            if (!p) return a;
            var was = Number(p.getAttribute('data-compare') || 0);
            var now = Number(p.getAttribute('data-price') || 0);
            return a + (was > now ? was : now);
          }, 0)
        : 0;
      if (priced && wasTotal > sum) {
        totalWasEl.textContent = money(wasTotal);
        totalWasEl.hidden = false;
        saveEl.textContent = Math.round(((wasTotal - sum) / wasTotal) * 100) + '% off';
        saveEl.hidden = false;
      } else {
        totalWasEl.hidden = true;
        saveEl.hidden = true;
      }
    }

    /*
     * A size still to pick is not an error, it is the next thing to do - so the
     * button names it rather than going dead with no explanation.
     */
    if (!on.length) {
      addBtn.disabled = true;
      addLabel.textContent = 'Choose at least one piece';
    } else if (missing.length) {
      addBtn.disabled = true;
      addLabel.textContent = 'Choose a ' + missing[0].getAttribute('data-role').replace('trouser', 'trouser') + ' size';
    } else {
      addBtn.disabled = false;
      addLabel.textContent = 'Add to bag — ' + money(sum);
    }
  }

  /*
   * Start on the sizes the shop has already worked out for him.
   *
   * The suit's own picker is gone, so there is no chosen variant to read. What
   * there may be is the fit note - "Chosen for you: 40\" Jacket 34\" Trousers" -
   * written by tc-fit-size from the customer's saved chest. Where it exists the
   * first number is the chest and the second the waist. Where it does not, the
   * sizes are left unset: guessing on a page whose whole point is that the
   * standard drop did not fit would be a poor joke.
   */
  function preselect() {
    var note = document.querySelector('.tcfr__fitnote');
    var nums = note && String(note.textContent).match(/\d+(?:\.\d+)?/g);
    if (!nums || nums.length < 1) return;
    var chest = nums[0];
    var waist = nums.length > 1 ? nums[1] : nums[0];

    rows.forEach(function (r) {
      if (pickedIn(r)) return;
      var want = r.getAttribute('data-role') === 'trouser' ? waist : chest;
      var hit = sizesIn(r).find(function (b) {
        if (b.disabled) return false;
        var n = (b.textContent.match(/\d+(?:\.\d+)?/) || [])[0];
        return n === want;
      });
      if (hit) choose(r, hit);
    });
    draw();
  }

  function add() {
    var on = chosen();
    if (!on.length || on.some(function (r) { return !pickedIn(r); })) return;

    addBtn.disabled = true;
    addLabel.textContent = 'Adding…';
    note.hidden = true;
    note.classList.remove('is-bad');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: on.map(function (r) {
          return { id: Number(pickedIn(r).getAttribute('data-id')), quantity: 1 };
        }),
      }),
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.body && res.body.description) || 'That could not be added.');
        /* The theme's own drawer, told the way the theme tells it.
           on:cart:change rather than the drawer's own refresh event: the
           drawer listens to both, but the header only listens to this one,
           and without it the basket icon still reads the count from the last
           page load - three pieces added under a badge saying nothing. */
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
        draw();
      })
      .catch(function (err) {
        note.textContent = err.message;
        note.classList.add('is-bad');
        note.hidden = false;
        draw();
      });
  }

  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-tcsep-size]');
    if (!btn || btn.disabled) return;
    choose(btn.closest('[data-tcsep-row]'), btn);
    draw();
  });
  root.addEventListener('change', draw);
  addBtn.addEventListener('click', add);

  draw();
  preselect();
  /* The fit note is written after this script runs, so look again once. */
  setTimeout(preselect, 600);
})();
